<template>
	<div>
		<div class="flex items-center">
            <div>
                <md-button class="md-icon-button md-raised md-info my-0" :disabled="adding" @click="addInterventionPrevision">
                    <font-awesome-icon class="md-icon" :icon="['fa', adding ? 'sync-alt' : 'plus']" :class="{ 'animate-spin': adding }" />
                </md-button>
                <md-tooltip md-direction="top">Ajouter une intervention</md-tooltip>
            </div>
			<span class="font-medium ml-3">{{ month.label }}</span>
		</div>
		<template v-if="interventionPrevisions.length > 0">
			<intervention-plan-edit-intervention-row
				v-for="prevision in interventionPrevisions"
				:key="prevision.id"
				:prevision="prevision"
				:errors="previsionErrors(prevision)"
                :deviceGroups="deviceGroups"
                @update-prevision="$emit('update-prevision', $event)"
				@deactivate-prevision="$emit('deactivate-prevision', $event)">
			</intervention-plan-edit-intervention-row>
		</template>
        <p v-else class="mt-1">Aucune intervention pour {{ month.label }}</p>
	</div>
</template>

<script>
import InterventionPlanEditInterventionRow from "@/pages/Contracts/InterventionPlan/components/InterventionPlanEditInterventionRow";
export default {
	name: "InterventionPlanEditRow",
	components: {
		InterventionPlanEditInterventionRow
	},
	props: {
		month: {
			type: Object,
			default() {
				return {
					label: '',
					value: '',
				}
			}
		},
		previsions: Array,
        groupId: Number,
        deviceGroups: Array,
        rowErrors: Array
	},
	data() {
		return {
			previsionsCount: 0,
            interventionPrevisions: this.previsions,
            errors: _.cloneDeep(this.rowErrors),
			adding: false
		}
	},
	methods: {
		async addInterventionPrevision() {
			this.adding = true
			try {
				const { data } = await this.$store.dispatch('interventionPlans/addInterventionPrevision', {
					month: this.month.value,
					planning_intervention_group_id: this.groupId
				})
				await this.$store.dispatch('alerts/success', 'Intervention ajoutée')
				await this.$emit('add-prevision', data)
			} catch (error) {
				await this.$store.dispatch('alerts/error', 'Ajout impossible')
			} finally {
				this.adding = false
			}
		},
        previsionErrors(intervention) {
		    let errors = _.cloneDeep(this.errors)
            return errors.filter(error => { return error.interventionId === intervention.id })
        }
	},
    watch: {
	    rowErrors(newVal) {
            this.errors = newVal
        },
        previsions(newVal) {
	        this.interventionPrevisions = newVal
        },
    },
	mounted() {
		this.previsionsCount = this.interventionPrevisions.length
	}
}
</script>

<style scoped>

</style>
